(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lotus-hero-banners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lotus-hero')) {
  customElements.define('lotus-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.options = { signal: this.abort.signal };
      this.slides = Array.from(this.querySelectorAll('.lotus-hero__slide'));
      this.controls = this.querySelector('.lotus-hero__controls');
      this.dots = Array.from(this.querySelectorAll('[data-slide]'));
      this.pauseButton = this.querySelector('[data-action="pause"]');
      this.status = this.querySelector('[data-status]');
      this.index = 0;
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.inViewport = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoEnabled = this.dataset.autoRotate === 'true' && !window.Shopify?.designMode;
      this.interval = Math.max(5000, Number(this.dataset.interval) || 8000);
      if (!this.controls || this.slides.length < 2) return;
      this.controls.hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.dataset.slide !== undefined) this.show(Number(button.dataset.slide), true);
        if (button.dataset.action === 'previous') this.show(this.index - 1, true);
        if (button.dataset.action === 'next') this.show(this.index + 1, true);
        if (button.dataset.action === 'pause') this.userPaused = !this.userPaused;
        this.schedule();
      }, this.options);
      this.addEventListener('keydown', event => {
        if (!event.target.closest('.lotus-hero__controls')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1), true);
          this.schedule();
        }
      }, this.options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
      }, this.options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, this.options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, this.options);
      this.addEventListener('focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, this.options);
      const track = this.querySelector('.lotus-hero__slides');
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' || event.target.closest('a,button')) return;
        this.swipe = { x: event.clientX, y: event.clientY };
      }, this.options);
      track.addEventListener('pointerup', event => {
        if (!this.swipe) return;
        const dx = event.clientX - this.swipe.x;
        const dy = event.clientY - this.swipe.y;
        this.swipe = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.show(this.index + (dx < 0 ? 1 : -1), true);
          this.schedule();
        }
      }, this.options);
      track.addEventListener('pointercancel', () => { this.swipe = null; }, this.options);
      document.addEventListener('visibilitychange', () => this.schedule(), this.options);
      this.motion.addEventListener('change', () => this.schedule(), this.options);
      document.addEventListener('shopify:block:select', event => {
        const next = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (next >= 0) { this.userPaused = true; this.show(next, false); this.schedule(); }
      }, this.options);
      this.observer = new IntersectionObserver(entries => {
        this.inViewport = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: .1 });
      this.observer.observe(this);
      this.show(0, false);
      this.schedule();
    }
    show(next, announce) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      if (announce && this.status) this.status.textContent = this.dataset.statusTemplate.replace('[current]', String(this.index + 1));
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.pauseButton) return;
      this.pauseButton.hidden = !this.autoEnabled || this.motion.matches;
      this.pauseButton.textContent = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
      if (this.autoEnabled && !this.userPaused && !this.motion.matches && !this.hovered && !this.focused && !document.hidden && this.inViewport) {
        this.timer = setTimeout(() => { this.show(this.index + 1, false); this.schedule(); }, this.interval);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
